import MapConfigService from "@/services/MapConfigService";
import { reverseGeocode as mapboxReverseGeocode } from "@/services/MapboxGeocoding";

// Convert a Google place/geocoder result to the provider-neutral place shape:
// { place_id, formatted_address, lat, lng }
export function googlePlaceToPlace(place) {
  if (place == null || place.geometry == null) return null;
  return {
    place_id: place.place_id,
    formatted_address: place.formatted_address,
    name: place.name,
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng(),
  };
}

// Reverse geocode a location with the selected map provider.
// Resolves to a neutral place, or null when nothing was found.
export function reverseGeocode(lat, lng) {
  return MapConfigService.getConfig().then((config) => {
    if (!config.configured) {
      throw new Error("maps are not configured");
    }
    if (config.provider === "mapbox") {
      return mapboxReverseGeocode(lat, lng, config);
    }
    const geocoder = new window.google.maps.Geocoder();
    return geocoder
      .geocode({ location: { lat, lng } })
      .then((response) => googlePlaceToPlace(response.results[0]));
  });
}
